import { useNavigate } from 'react-router-dom';

export default function WhatIsSection() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="relative">
            <div className="aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Person%20using%20tablet%20to%20browse%20organized%20fashion%20product%20catalog%20while%20sitting%20on%20modern%20sofa%2C%20warm%20natural%20lighting%20through%20window%2C%20cozy%20minimalist%20interior%2C%20cream%20and%20beige%20tones%2C%20editorial%20lifestyle%20photography%2C%20comfortable%20home%20shopping%20atmosphere&width=800&height=600&seq=whatis-section-unique&orientation=landscape"
                alt="Basetao Spreadsheet explained - organized shopping resources"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-3 -right-3 bg-primary-500 text-background-50 px-4 py-2 rounded-md text-xs font-medium">
              Updated August 2026
            </div>
          </div>

          <div>
            <span className="inline-block text-xs font-semibold text-primary-600 uppercase tracking-wider mb-3">
              Getting Started
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">
              What Is Basetao Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                A <strong>Basetao Spreadsheet</strong> is a carefully organized document that compiles product links, pricing details, quality assessments, and shopping insights for products available through the Basetao platform. These spreadsheets serve as comprehensive shopping companions that help buyers navigate the vast product catalog with confidence and clarity.
              </p>
              <p>
                Thousands of international shoppers rely on <strong>Basetao Spreadsheet</strong> resources to discover trending products, compare prices across categories, understand shipping options, and verify product quality before making a purchase. The structured format makes it easy to browse through hundreds of curated finds organized by category.
              </p>
              <p>
                Whether you are new to Basetao or an experienced shopper looking to optimize your purchasing strategy, a well-maintained <strong>Basetao Spreadsheet</strong> provides the organized information you need to shop smarter, save money, and avoid common buying mistakes.
              </p>
            </div>
            <button
              onClick={() => navigate('/basetao-spreadsheet-guide')}
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 bg-secondary-500 text-background-50 text-sm font-medium rounded-md hover:bg-secondary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              Read The Complete Guide
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}